import React from 'react';

const UnlockIcon = ({ width = 18, height = 18, color = '#ffffff', style = {} }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect x="3" y="11" width="18" height="11" rx="2" stroke={color} strokeWidth="2" />
    <path
      d="M7 11V7a5 5 0 0 1 9.9-1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="12" cy="16" r="1.5" fill={color} />
  </svg>
);

export default UnlockIcon;
